module.exports = __webpack_public_path__ + "static/img/support_3.3f3fe08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/support_3.png
// module id = YK0r
// module chunks = 0